import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const DEFAULT_MAX = 110

function scoreHue(score: number, max: number): string {
  const cap = Math.min(100, max)
  const t = Math.max(0, Math.min(1, score / cap))
  return `hsl(${Math.round(120 * t)}, 70%, 42%)`
}

function arcPath(cx: number, cy: number, r: number): string {
  return `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`
}

export function TestScoreGauge({
  score,
  max = DEFAULT_MAX,
  titleUnknown,
}: {
  score: number | null | undefined
  max?: number
  titleUnknown: string
}) {
  const theme = useTheme()
  const unknown = score == null || Number.isNaN(Number(score))
  const r = 44
  const cx = 52
  const cy = 52
  const d = arcPath(cx, cy, r)
  const arcLen = Math.PI * r
  const ratio = unknown ? 0 : Math.max(0, Math.min(1, Number(score) / max))
  const dash = `${arcLen * ratio} ${arcLen}`

  const trackColor = theme.palette.action.disabled
  const fillColor = unknown ? theme.palette.action.disabled : scoreHue(Number(score), max)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: { xs: 100, sm: 120 } }}>
      <Box sx={{ position: 'relative', width: 104, height: 58 }}>
        <svg width="104" height="58" viewBox="0 0 104 58" aria-hidden>
          <path d={d} fill="none" stroke={trackColor} strokeWidth={8} strokeLinecap="round" />
          <path d={d} fill="none" stroke={fillColor} strokeWidth={8} strokeLinecap="round" strokeDasharray={dash} />
        </svg>
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            position: 'absolute',
            left: '50%',
            bottom: 2,
            transform: 'translateX(-50%)',
            lineHeight: 1,
            color: unknown ? 'text.disabled' : 'text.primary',
          }}
          title={unknown ? titleUnknown : undefined}
        >
          {unknown ? '?' : Math.round(Number(score))}
        </Typography>
      </Box>
    </Box>
  )
}
